<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    :show-close="false"
    top="4vh"
    width="55%"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('public.viewDetail')"
      :icon="'icon-common-query'"
      @close="closeDialog"
    />
    <div style="height:70vh;">
      <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
        <vue-linetitle
          :icon-config="{icon:'car-infomation'}"
          :title="`${$t('carManagement.createAndUpdate.title1')}`"
        >
          <el-row>
            <el-col :span="12">
              <el-form
                size="mini"
                :model="formInfo"
                :label-position="'right'"
                :label-width="$t('carManagement.createAndUpdate.leftLabelWidth')"
              >
              <el-form-item :label="$t('public.licensePlate') + '：'">
                  <vue-licenseplate
                    :types="formInfo.isTempCar"
                    :licensepalte="formInfo.licensePlate"
                    :area="formInfo.areaName"
                  />
                </el-form-item>
                <el-form-item :label="$t('carManagement.brand') + '：'">
                  <span>{{ formInfo.brandName }}</span>
                </el-form-item>
                <el-form-item :label="$t('carManagement.model') + '：'">
                  <span>{{ formInfo.modelName }}</span>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form
                size="mini"
                :model="formInfo"
                :label-position="'right'"
                :label-width="$t('carManagement.createAndUpdate.rightLabelWidth')">
                <el-form-item :label="$t('carManagement.fuelType')+'：'" style="margin-bottom: 42px !important">
                  <span>{{ formInfo.fuelType }}</span>
                </el-form-item>
                <el-form-item :label="$t('carManagement.series')+'：'">
                  <span>{{ formInfo.seriesName }}</span>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </vue-linetitle>

        <vue-linetitle
          :icon-config="{icon:'car-ower'}"
          :title="`${$t('carManagement.createAndUpdate.title2')}`"
        >
          <el-row>
            <el-col :span="12">
              <el-form
                size="mini"
                :model="formInfo"
                :label-position="'right'"
                :label-width="$t('carManagement.createAndUpdate.leftLabelWidth')">
                <el-form-item :label="$t('public.mobile') + '：'">
                  <span>{{ formInfo.loginName }}</span>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form
                size="mini"
                :model="formInfo"
                :label-position="'right'"
                :label-width="$t('carManagement.createAndUpdate.rightLabelWidth')">
                <el-form-item :label="$t('carManagement.maxSpeed') + '：'">
                  <span>{{ formInfo.maxSpeed }}km/h</span>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </vue-linetitle>

        <vue-linetitle
          :icon-config="{icon:'car-OBD'}"
          :title="`${$t('carManagement.createAndUpdate.title3')}`">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form
                size="mini"
                :model="formInfo"
                :label-position="'right'"
                :label-width="$t('carManagement.createAndUpdate.leftLabelWidth')">
                <el-form-item :label="$t('public.obdCode') + '：'">
                  <span>{{ formInfo.barCode }}</span>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </vue-linetitle>
        <vue-linetitle
          :icon-config="{icon:'approve-car'}"
          :title="`${$t('carManagement.boundHistory')}`">
          <div style="min-height: 50px">
            <el-timeline style="padding-left: 15px" v-for="(itemArray, index) in list" :key="index">
              <el-timeline-item
                v-for="(item, i) in itemArray"
                :key="i"
                :timestamp="item.createdOn"
                color="#409eff"
                placement="top" 
                hide-timestamp>
              <p style="padding: 3px 0;margin-top: 0">
                    <span style="color: #909399"> {{ item.createdOn }} </span>
                    <span :style="{color: !item.type ? '#409EFF': '#ff0000'}">{{ item.type ? $t('public.unbind') : $t('public.bind') }}</span>
                    </p>
                <el-card 
                :body-style="{padding: '10px'}"
                style="width: calc(100% - 30px)">
                  <h4>
                    {{ item.barCode  }}
                    <!-- {{ item.barCode }}  -->
                  </h4>
                  <p>{{ item.note }}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
            <div v-show="list.length==0" style="text-align: center;margin-top: 30px">{{ $t('book.historyTrack.noData') }}</div>
            </div>
        </vue-linetitle>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { getCarHistory } from '@/api/userCenter/carManagement'
export default {
  name: 'LookCarDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formInfo: {
        ispermanentlicence: 1
      },
      showCarOwner: false,
      list: []
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = { ...this.data }
        this.formInfo.isPrivate === 1 && (this.showCarOwner = true)
        this.listLoad()
      }
    }
  },
  created() {
  },
  methods: {
    listLoad() {
      if (!this.visibles) return
      // {"note":" Unbind note:test1","startTime":"2020-07-13 11:57:46","endTime":"2020-07-16 09:13:36","barCode":"V2A1002W"}
      getCarHistory(this.formInfo.carId).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          const result = data.data || []
          result.forEach(item=>{
            let arr = []
            arr.push({
              createdOn: item.startTime,
              barCode: item.barCode,
              note: item.bindNote,
              type: 0
            })
            if(item.endTime) {
              arr.push({
              createdOn: item.endTime,
              barCode: item.barCode,
              note: item.unbindNote,
              type: 1
              })
            }
            this.list.push(arr)
          })
        }
        // this.listLoading = false
      })
    },
    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
      this.formInfo = {}
      this.list = []
      this.showCarOwner = false
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    }
  }
}
</script>

<style lang='scss' scoped>
p,h4{
  margin: 4px 0;
}
.cell-class-detail{
    .el-form-item__content{
        display: flex;
    }
    .license-new{
        line-height: 23px;
    }
    .license-message{
        line-height: 46px;
        color: #1313FD;
        margin-left: 12px;
    }
}
.car-collapse{
    padding-right: 10px;
    img{
        width: 125px;
        height:125px;
    }
}

// .cell-class{
//     display: flex;
//     .svg-icon{
//       font-size:40px!important;
//       margin: 17px 15px 27px 0;
//     }
//     .el-radio-group{
//         margin: 8px;
//         width: 80px;
//         .el-radio{
//             padding: 10px 0 0 10px;
//         }
//     }
// }

</style>
